import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type RespirationIconProps = Partial<SVGIconProps>;

const RespirationIcon: FC<RespirationIconProps> = (props) => (
  <SVGIcon viewBox="0 0 39 29" {...props}>
    <path
      d="M33.1128 4.64941C30.6491 4.64941 28.6448 6.62566 28.6448 9.05488C28.6448 10.9658 30.2215 12.5204 32.1595 12.5204V10.272C31.4789 10.272 30.9251 9.72602 30.9251 9.05488C30.9251 7.86549 31.9066 6.89779 33.1128 6.89779C35.056 6.89779 36.6367 8.45651 36.6367 10.3723C36.6367 13.3063 34.2159 15.6933 31.2403 15.6933H0V17.9416H22.7016C25.6773 17.9416 28.0981 20.3287 28.0981 23.2626C28.0981 25.1784 26.5172 26.7371 24.5742 26.7371C23.3679 26.7371 22.3865 25.7694 22.3865 24.58C22.3865 23.9089 22.9402 23.3629 23.6209 23.3629V21.1146C21.6829 21.1146 20.1062 22.6692 20.1062 24.58C20.1062 27.0093 22.1105 28.9855 24.5742 28.9855C27.7746 28.9855 30.3784 26.4182 30.3784 23.2626C30.3784 21.1902 29.5291 19.3099 28.156 17.9416H31.2403C35.4732 17.9416 38.917 14.5461 38.917 10.3723C38.917 7.21676 36.3132 4.64941 33.1128 4.64941Z"
      fill="currentColor"
    />
    <path
      d="M26.7048 5.72306C26.7048 2.56746 24.101 0.00012207 20.9006 0.00012207C18.4369 0.00012207 16.4326 1.97637 16.4326 4.40558C16.4326 6.31648 18.0092 7.87108 19.9472 7.87108V5.6227C19.2666 5.6227 18.7129 5.07672 18.7129 4.40558C18.7129 3.2162 19.6942 2.24849 20.9006 2.24849C22.8436 2.24849 24.4245 3.80722 24.4245 5.72306C24.4245 8.65696 22.0035 11.044 19.028 11.044H0V13.2924H19.028C23.261 13.2924 26.7048 9.89686 26.7048 5.72306Z"
      fill="currentColor"
    />
    <path
      d="M4.05469 6.39563H13.7839V8.644H4.05469V6.39563Z"
      fill="currentColor"
    />
    <path
      d="M4.05469 20.3418H17.3311V22.5902H4.05469V20.3418Z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default RespirationIcon;
